import { SearchParams } from '@/types/common'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'
import {
  IFormCisFertigation,
  IFormCisFertigationMode,
} from '@/types/cisFertigation'

const cisFertigationDataConfig = {
  getAll(interfaceId: string, pipeId: string, searchParams: SearchParams = {}) {
    const url = `/api/CisFertigation/${interfaceId}/${pipeId}`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getByPipes(interfaceId: string, pipeIds: number[]) {
    const url = `/api/CisFertigation/get-list-by-pipes/${interfaceId}`
    return axiosClient.get(url + queryStringify({ pipeIds }))
  },

  getById(id: string) {
    const url = `/api/CisFertigation/${id}`
    return axiosClient.get(url)
  },

  create(data: IFormCisFertigation) {
    const url = `/api/CisFertigation`
    return axiosClient.post(url, data)
  },
  edit(data: IFormCisFertigation) {
    const url = `/api/CisFertigation`
    return axiosClient.put(url, data)
  },
  delete(id: string) {
    const url = `/api/CisFertigation/${id}`
    return axiosClient.delete(url)
  },

  getFertiliserOption(interfaceId: string, cisFertigationId?: string) {
    const url = `/api/CisFertigation/fertiliser-not-use`
    return axiosClient.get(
      url + queryStringify({ interfaceId, cisFertigationId }),
    )
  },

  getAgitatorOption(interfaceId: string, cisFertigationId?: string) {
    const url = `/api/CisFertigation/agitator-not-use`
    return axiosClient.get(
      url + queryStringify({ interfaceId, cisFertigationId }),
    )
  },

  getFlushingOption(interfaceId: string, cisFertigationId?: string) {
    const url = `/api/CisFertigation/flushing-not-use`
    return axiosClient.get(
      url + queryStringify({ interfaceId, cisFertigationId }),
    )
  },

  getflowSensorOption(interfaceId: string, cisFertigationId?: string) {
    const url = `/api/CisFertigation/flow-sensor-not-use`
    return axiosClient.get(
      url + queryStringify({ interfaceId, cisFertigationId }),
    )
  },

  getPumpStartOption(interfaceId: string, cisFertigationId?: string) {
    const url = `/api/CisFertigation/pump-start-not-use`
    return axiosClient.get(
      url + queryStringify({ interfaceId, cisFertigationId }),
    )
  },
  getWaterLevelSensorOption(interfaceId: string, cisFertigationId?: string) {
    const url = `/api/CisFertigation/water-level-not-use`
    return axiosClient.get(
      url + queryStringify({ interfaceId, cisFertigationId }),
    )
  },
  getFertigationMode(interfaceId: number, id: number) {
    const url = `/api/Pipe/${id}/fertigation-mode/`
    return axiosClient.get(url + queryStringify({ interfaceId }))
  },
  editFertigationMode(data: IFormCisFertigationMode) {
    const url = `/api/Pipe/fertigation-mode`
    return axiosClient.put(url, data)
  },
}

export default cisFertigationDataConfig
